import * as React from "react"

interface IconProps {
  color?: string
}

export const ArrowDropDownIcon: React.FunctionComponent<IconProps> = ({ color = "#616161" }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="arrow-drop-down"
  >
    <path d="M7 9.5L12 14.5L17 9.5L7 9.5Z" fill={color} />
  </svg>
)
